module.exports = __webpack_public_path__ + "static/media/education_blog_icon.5123a0c8.svg";